<template>
  <div class="d-flex" v-bind="attrs" >
    <!-- <div class="cont-icon mr-1 mb-1" v-if="!!sIcono">
      <v-icon size="37px">{{ sIcono }}</v-icon>
    </div> -->
    <div class="cont-dato ml-1 text-center">
      <h2 :class="[!!attrs?.bWidgetGrafica ? 'text-grafica' : '', 'titledata--text', 'text-medium', '']">
        {{ aData[1][0] || 0 }}
      </h2>
      <!-- <p v-if="!!sLabel" class="text-center">{{ sLabel }}</p> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    sIcono: {
      type: String,
      default: () => "",
    },
    sLabel: {
      type: String,
      default: () => "",
    },
    aData: {
      type: Array,
      default: () => [],
    },
    attrs: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.text-grafica {
    font-size: 1.9em !important;
    font-weight: bold !important; 
    letter-spacing: 0.1px !important;
}
.cont-dato {
  margin: 0px 10px;
  h2 {
    font-size: 3em;
    font-weight: 400;
    letter-spacing: -3px;
    margin: 0px;
    padding: 0px;
    line-height: 1em;
  }
  p {
    font-size: 0.875rem;
    margin: 0px;
  }
}
.cont-icon {
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-content: center;
  border-radius: 50%;
  border: solid gray 1px;
}
</style>